


<div class="my-panel no-shadow {{_class}}"  *ngIf="!appService.user && appService.enableLogin" (click)="dialogsService.login($storage.contact, position)">
	<div class="my-panel-body">
		<mat-icon svgIcon="logo" class="mr-2"></mat-icon>
		<div class="_inner">
			<span>{{'_LOYALTY.banner_title_start' | translate}}</span>
			<img src="/assets/images/logo-light.svg">
			<span>{{'_LOYALTY.banner_title_end' | translate}}</span>
		</div>
	</div>
</div>
